"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NotFoundV3Controller", {
    enumerable: true,
    get: function() {
        return NotFoundV3Controller;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const NOT_FOUND_PATH_PREFIX = '/api/v3/*';
let NotFoundV3Controller = class NotFoundV3Controller {
    async notFoundV3(req) {
        return {
            error: 'NOT_FOUND',
            message: `Cannot ${req.method} ${req.path}`
        };
    }
};
_ts_decorate([
    (0, _common.All)(NOT_FOUND_PATH_PREFIX),
    (0, _common.HttpCode)(404),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], NotFoundV3Controller.prototype, "notFoundV3", null);
NotFoundV3Controller = _ts_decorate([
    (0, _common.Controller)()
], NotFoundV3Controller);
